import { db } from '../firebase';
import { 
  collection, 
  addDoc, 
  query, 
  where, 
  getDocs,
  deleteDoc,
  updateDoc,
  doc 
} from 'firebase/firestore';

export const createTransaction = async (userId, transactionData) => {
  return await addDoc(collection(db, 'transactions'), {
    userId,
    ...transactionData,
    createdAt: new Date()
  });
};

export const getTransactions = async (userId, filters = {}) => {
  let q = query(
    collection(db, 'transactions'), 
    where('userId', '==', userId)
  );
  
  const snapshot = await getDocs(q);
  const transactions = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  
  // Ordenar en el cliente en lugar de en Firestore
  return transactions.sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateB - dateA; // Orden descendente (más reciente primero)
  });
};

export const updateTransaction = async (transactionId, data) => {
  const transactionRef = doc(db, 'transactions', transactionId);
  return await updateDoc(transactionRef, data);
};

export const deleteTransaction = async (transactionId) => {
  return await deleteDoc(doc(db, 'transactions', transactionId));
};
